import get from 'lodash/get';

import { AppRootState } from '../../../../../../../../store/models/app-state.model';
import { REVIEWS } from '../../../../../../../../store/utils/files-names';
import { ReviewFiltersModel } from '../../../../thunks/models/review-filters.model';

export const getReviewFiltersSelector = (
  state: AppRootState
): ReviewFiltersModel => get(state, REVIEWS).filtersDropdownValues;
